import { Dropdown, Input, Tooltip } from "antd";
import {
  ArrowUpDown,
  ChevronDown,
  CircleX,
  Download,
  Filter,
  Folder,
  ListFilter,
  Plus,
  RefreshCcw,
  Search,
  Upload,
  User,
  UserRoundX,
  Users2,
  X,
} from "lucide-react";
import React, { useState } from "react";
import Loader from "../../../../Loader";
import AssignInterviewBatchModal from "./assignInterviewModal/AssignInterviewBatchModal";
import AssignInterviewCandidateModal from "./assignInterviewModal/AssignInterviewCandidateModal";
import UnassignBatchModal from "./unassignGuideModal/UnassignMockBatchModal";
import FilterMockModal from "./FilterMockModal";

function InterviewSearchSec({
  studentsData,
  searchText,
  setSearchText,
  setSearchValue,
  selectedUserIds,
  refreshApis,
  setUnAssignStudentFlag,
  unAssignStudentFlag,
  searchValue,
  setSortBy,
  sortBy,
  setInterviewState,
  interviewState,
  batchIdsFilter,
  setBatchIdsFilter,
  iDronaId,
}) {
  // console.log(selectedUserIds)
  const [assignGuideBatchFlag, setAssignGuideBatchFlag] = useState(false);
  const [assignGuideCandidateFlag, setAssignCandidateBatchFlag] =
    useState(false);
  const [unAssignGuideBatchFlag, setUnAssignGuideBatchFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mockFilterFlag, setMockFilterFlag] = useState(false);

  const unassignItems = [
    {
      key: "student",
      label: (
        <div className="flex items-center gap-2 text-[.85rem] p-[.25rem]">
          <User size={16} />
          Unassign Selected Students
        </div>
      ),
      disabled: selectedUserIds?.length < 1,
    },
    {
      key: "batch",
      label: (
        <div className="flex items-center gap-2 text-[.85rem] p-[.25rem]">
          <Users2 size={16} />
          Unassign Batch
        </div>
      ),
    },
  ];
  const assignItems = [
    {
      key: "student",
      label: (
        <div className="flex items-center gap-2 text-[.85rem] p-[.25rem]">
          <User size={16} />
          Assign to Student
        </div>
      ),
    },
    {
      key: "batch",
      label: (
        <div className="flex items-center gap-2 text-[.85rem] p-[.25rem]">
          <Users2 size={16} />
          Assign to Batch
        </div>
      ),
    },
  ];

  const sortItems = [
    {
      key: "SORT_BY_ASSIGNED_DATE_ASC",
      label: "Assigned Date (Old-New)",
    },
    {
      key: "SORT_BY_ASSIGNED_DATE_DESC",
      label: "Assigned Date (New-Old)",
    },
    {
      key: "SORT_BY_CANDIDATE_NAME_ASC",
      label: "Candidate Name (A-Z)",
    },
    {
      key: "SORT_BY_CANDIDATE_NAME_DESC",
      label: "Candidate Name (Z-A)",
    },
    {
      key: "SORT_BY_BATCH_NAME_ASC",
      label: "Batch Name (A-Z)",
    },
    {
      key: "SORT_BY_BATCH_NAME_DESC",
      label: "Batch Name (Z-A)",
    },
  ];

  return (
    <>
      {loading && <Loader />}
      {assignGuideBatchFlag && (
        <AssignInterviewBatchModal
          assignGuideBatchFlag={assignGuideBatchFlag}
          setAssignGuideBatchFlag={setAssignGuideBatchFlag}
          setLoading={setLoading}
          refreshApis={refreshApis}
        />
      )}
      {assignGuideCandidateFlag && (
        <AssignInterviewCandidateModal
          assignGuideCandidateFlag={assignGuideCandidateFlag}
          setAssignCandidateBatchFlag={setAssignCandidateBatchFlag}
          setLoading={setLoading}
          refreshApis={refreshApis}
        />
      )}
      {unAssignGuideBatchFlag && (
        <UnassignBatchModal
          setLoading={setLoading}
          setUnAssignGuideBatchFlag={setUnAssignGuideBatchFlag}
          unAssignGuideBatchFlag={unAssignGuideBatchFlag}
          refreshApis={refreshApis}
        />
      )}
      {mockFilterFlag && (
        <FilterMockModal
          mockFilterFlag={mockFilterFlag}
          setMockFilterFlag={setMockFilterFlag}
          setInterviewState={setInterviewState}
          interviewState={interviewState}
          batchIdsFilter={batchIdsFilter}
          setBatchIdsFilter={setBatchIdsFilter}
          iDronaId={iDronaId}
          setLoading={setLoading}
        />
      )}
      <div className="">
        <div className="flex justify-between mb-3 gap-2 flex-wrap">
          <div className="flex gap-x-[.65rem] gap-y-2 items-center flex-wrap">
            <div>
              <Input
                prefix={<Search size={15} />}
                suffix={
                  searchText || searchValue ? (
                    <button
                      type="button"
                      onClick={() => {
                        setSearchText("");
                        setSearchValue("");
                      }}
                      className="flex items-center justify-center text-gray-500 hover:text-gray-700"
                    >
                      <CircleX size={15} />
                    </button>
                  ) : null
                }
                placeholder="Search students..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                onPressEnter={(e) => setSearchValue(e.target.value)}
              />
            </div>
            <button
              onClick={() => setMockFilterFlag(true)}
              className={`flex gap-x-[6px] items-center border-[1px] border-gray-300 rounded-md px-3 py-[5px] text-[.85rem] text-[#344054] ${interviewState !== "ALL" || batchIdsFilter !== null ? "bg-orange-100 border-orange-300" : "border-gray-300"}`}
            >
              <ListFilter size={14} />
              Filter{" "}
              {(interviewState !== "ALL" || batchIdsFilter !== null) && (
                <X
                  className="cursor-pointer hover:text-orange-500 duration-200 transition-all ease-in-out"
                  onClick={(e) => {
                    setBatchIdsFilter(null);
                    setInterviewState("ALL");
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                  size={14}
                />
              )}
            </button>
            <Dropdown
              menu={{
                // items: sortItems,
                items: sortItems.map((item) => ({
                  ...item,
                  className:
                    sortBy === item.key
                      ? "!bg-orange-50 !text-[#DC6803] font-semibold"
                      : "",
                })),
                selectedKeys: [sortBy],
                onClick: ({ key }) => {
                  setSortBy(key);
                },
              }}
              trigger={["click"]}
            >
              <button className="flex gap-x-[6px] items-center border-[1px] border-gray-300 rounded-md px-3 py-[5px] text-[.85rem] text-[#344054]">
                <ArrowUpDown size={14} />
                Sort by
              </button>
            </Dropdown>
            {/* <Tooltip
            overlayInnerStyle={{
              backgroundColor: "black",
              borderRadius: 8,
              fontSize: ".85rem",
              padding: "6px 10px",
            }}
            title="Refresh Table"
          >
            <button
              className="ml-1"
              onClick={() => setRefressGetApi((prev) => prev + 1)}
            >
              <RefreshCcw color="#344054" size={19} />
            </button>
          </Tooltip> */}
          </div>
          <div className="flex gap-x-3 gap-y-2 items-center flex-wrap">
            <Dropdown
              menu={{
                items: unassignItems,
                onClick: ({ key }) => {
                  if (key === "batch") {
                    setUnAssignGuideBatchFlag(true);
                  }
                  if (key === "student") {
                    setUnAssignStudentFlag(true);
                  }
                },
              }}
              trigger={["click"]}
              placement="bottomLeft"
              overlayClassName="bulk-actions-dropdown"
              className="px-2 rounded-[6px]"
            >
              <button
                className="flex items-center gap-[.5rem] text-[#1D2939] hover:brightness-[1.1] transition-all duration-200 ease-in-out 
            px-[.9rem] py-[.45rem] border-[1px] border-[#EDC043] rounded-[6px] bg-[#EDC043]"
              >
                <span className="flex gap-3 items-center">
                  <span className="font-semibold text-[.8rem] flex gap-[.5rem] items-center">
                    Unassign Interview
                  </span>
                </span>
                <span className="">
                  <ChevronDown size={19} />
                </span>
              </button>
            </Dropdown>
            <Dropdown
              menu={{
                items: assignItems,
                onClick: ({ key }) => {
                  if (key === "batch") {
                    setAssignGuideBatchFlag(true);
                  }
                  if (key === "student") {
                    setAssignCandidateBatchFlag(true);
                  }
                },
              }}
              trigger={["click"]}
              placement="bottomLeft"
              overlayClassName="bulk-actions-dropdown"
              className="px-2 rounded-[6px]"
            >
              <button
                className="flex items-center gap-[.5rem] text-[#1D2939] hover:brightness-[1.1] transition-all duration-200 ease-in-out 
            px-[.9rem] py-[.45rem] border-[1px] border-[#EDC043] rounded-[6px] bg-[#EDC043]"
              >
                <span className="flex gap-3 items-center">
                  <span className="font-semibold text-[.8rem] flex gap-[.5rem] items-center">
                    Assign Interview
                  </span>
                </span>
                <span className="">
                  <ChevronDown size={19} />
                </span>
              </button>
            </Dropdown>
          </div>
        </div>
      </div>
    </>
  );
}

export default InterviewSearchSec;
